import React from 'react';
import {Link} from 'react-router-dom';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__12} from '@homeaway/svg-defs/lib/defs/CHEVRON_RIGHT__12';
import AspectRatioImage from 'components/AspectRatioImage/AspectRatioImage';
import './FeaturedCallOut.less';
import {HomeRouteContext} from 'utils/context';

const FeaturedCallOut = ({
    title,
    subtitle,
    image,
    link,
    parent,
    overview,
    withButton,
}) => {
    return (
        <div className="FeaturedCallOut">
            <AspectRatioImage
                {...image}
                className="FeaturedCallOut__col"
                linkComponent={(child) => <Link to={link}>{child}</Link>}
            />
            <div className="FeaturedCallOut__col">
                <div className="FeaturedCallOut__text-block">
                    <h2 className="FeaturedCallOut__headline">
                        <Link to={link}>
                            <span className="heading-hover-bg">{title}</span>
                        </Link>
                    </h2>
                    {subtitle && (
                        <p>
                            <HomeRouteContext.Consumer>
                                {(homeRoute) => (
                                    <Link to={homeRoute + parent.path}>
                                        <strong>{subtitle}</strong>
                                    </Link>
                                )}
                            </HomeRouteContext.Consumer>
                        </p>
                    )}
                    <p className="FeaturedCallOut__overview">{overview}</p>
                    {withButton && (
                        <Link
                            to={link}
                            className="FeaturedCallOut__link-button"
                        >
                            <SVGIcon markup={CHEVRON_RIGHT__12} />
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FeaturedCallOut;
